class UMGDates extends HTMLElement {
  connectedCallback () {
    const dataDates = JSON.parse(this.getAttribute('data-dates'))
    this.today = new Date()
    // add 18 hours for noon Central
    this.today.setHours(0, 0, 0, 0)
    this.latestDate = this.today
    this.init(dataDates)
  }

  init (dataDates) {
    let bundlesActive = false
    if (dataDates.length > 1) {
      bundlesActive = true
    }

    for (let i = 0; i < dataDates.length; i++) {
      const bundlesPropertiesPosition = i
      const fixedDateValue = dataDates[i].fixed
      const rollingDays = parseInt(dataDates[i].rolling)
      const componentFinalDate = this.finalDateFunc(fixedDateValue, rollingDays, bundlesPropertiesPosition)
      if (componentFinalDate >= this.latestDate) {
        this.latestDate = componentFinalDate
      }

      if (this.getAttribute('data-release-date-active') === 'true') {
        const productDates = this.querySelectorAll('.product__date')
        if (productDates.length === 1) {
          productDates[0].innerHTML = window.shipDateLabel.replace('{{ date }}', this.dateFormat(this.latestDate, true))
        } else if (productDates.length > 1) {
          let productDateString = window.shipDateLabelTitled
          productDateString = productDateString.replace('{{ title }}', dataDates[i].title)
          productDateString = productDateString.replace('{{ date }}', this.dateFormat(componentFinalDate, true))
          productDates[i].innerHTML = productDateString
        }
      }

      if (i === dataDates.length - 1 && dataDates[0].hide_limit) {
        const hideLimit = parseInt(dataDates[0].hide_limit)
        const hideDateCutoff = new Date(this.today)
        hideDateCutoff.setDate(hideDateCutoff.getDate() + hideLimit)
        if (componentFinalDate < hideDateCutoff) {
          // Hides PDP date if hide promise date cutoff is surpassed
          if (this.getAttribute('data-release-date-active') === 'true') {
            this.querySelector('.product__date').classList.add('hidden')
          } else {
            // Hides cart date if hide promise date cutoff is surpassed
            // this.querySelector('[name="properties[_shipdate_hidden_theme]"]').value = true
            if (this.closest('form[action="/cart/add"]') || (this.closest('.product-form'))) {
              const input = document.createElement('input')
              input.setAttribute('type', 'hidden')
              input.setAttribute('name', 'properties[_shipdate_hidden_theme]')
              input.setAttribute('value', 'true')
              input.setAttribute('aria-hidden', 'true')
              this.appendChild(input)
            }
          }
        }
      }
    }

    if (this.querySelector('.promise-msg')) {
      this.querySelector('.promise-msg').value = this.dateFormat(this.latestDate)
    }

    if (this.closest('product-form')) {
      const submitBtn = this.closest('product-form').querySelector('button[type="submit"]')
      const stickySubmitBtn = document.querySelector('.product-form__sticky-cta')
      if (!submitBtn.hasAttribute('data-unavailable')) {
        submitBtn.removeAttribute('disabled')
        submitBtn.setAttribute('aria-disabled', 'false')
        // remove disabled also from sticky button if exists
        if (stickySubmitBtn) {
          stickySubmitBtn.removeAttribute('disabled')
          stickySubmitBtn.setAttribute('aria-disabled', 'false')
        }
      }
      submitBtn.removeAttribute('x-cloak')
    }
    this.removeAttribute('x-cloak')
  }

  dateFormat (date, localisedDisplay = false) {
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }
    // const format = window.shipDateFormat || 'en-US'
    // return new Intl.DateTimeFormat(format, options).format(date)
    const format = 'en-US'
    let finalDate = new Intl.DateTimeFormat(format, options).format(date)

    if (window.shipLocaleFormat !== undefined && window.shipLocaleFormat !== 'en-US' && localisedDisplay) {
      const format = window.shipLocaleFormat
      finalDate = new Intl.DateTimeFormat(format, options).format(date)
      if (format === 'fr-FR') {
        finalDate = finalDate.replace('January', 'janvier')
        finalDate = finalDate.replace('February', 'février')
        finalDate = finalDate.replace('March', 'mars')
        finalDate = finalDate.replace('April', 'avril')
        finalDate = finalDate.replace('May', 'mai')
        finalDate = finalDate.replace('June', 'juin')
        finalDate = finalDate.replace('July', 'juillet')
        finalDate = finalDate.replace('August', 'août')
        finalDate = finalDate.replace('September', 'septembre')
        finalDate = finalDate.replace('October', 'octobre')
        finalDate = finalDate.replace('November', 'novembre')
        finalDate = finalDate.replace('December', 'décembre')
      }
      if (format === 'de-DE') {
        finalDate = finalDate.replace('January', 'Januar')
        finalDate = finalDate.replace('February', 'Februar')
        finalDate = finalDate.replace('March', 'März')
        finalDate = finalDate.replace('April', 'April')
        finalDate = finalDate.replace('May', 'Mai')
        finalDate = finalDate.replace('June', 'Juni')
        finalDate = finalDate.replace('July', 'Juli')
        finalDate = finalDate.replace('August', 'August')
        finalDate = finalDate.replace('September', 'September')
        finalDate = finalDate.replace('October', 'Oktober')
        finalDate = finalDate.replace('November', 'November')
        finalDate = finalDate.replace('December', 'December')
      }
      if (format === 'sv-SE') {
        finalDate = finalDate.replace('January', 'januari')
        finalDate = finalDate.replace('February', 'februari')
        finalDate = finalDate.replace('March', 'mars')
        finalDate = finalDate.replace('April', 'april')
        finalDate = finalDate.replace('May', 'maj')
        finalDate = finalDate.replace('June', 'juni')
        finalDate = finalDate.replace('July', 'juli')
        finalDate = finalDate.replace('August', 'augusti')
        finalDate = finalDate.replace('September', 'september')
        finalDate = finalDate.replace('October', 'oktober')
        finalDate = finalDate.replace('November', 'november')
        finalDate = finalDate.replace('December', 'december')
      }
      if (format === 'ro-RO') {
        finalDate = finalDate.replace('January', 'ianuarie')
        finalDate = finalDate.replace('February', 'februarie')
        finalDate = finalDate.replace('March', 'martie')
        finalDate = finalDate.replace('April', 'aprilie')
        finalDate = finalDate.replace('May', 'mai')
        finalDate = finalDate.replace('June', 'iunie')
        finalDate = finalDate.replace('July', 'iulie')
        finalDate = finalDate.replace('August', 'august')
        finalDate = finalDate.replace('September', 'septembrie')
        finalDate = finalDate.replace('October', 'octombrie')
        finalDate = finalDate.replace('November', 'noiembrie')
        finalDate = finalDate.replace('December', 'decembrie')
      }
    }

    return finalDate
  }

  finalDateFunc (fixedDateValue, rollingDays, bundlesPropertiesPosition) {
    let fixedDate
    if (fixedDateValue) {
      const [year, month, day] = fixedDateValue.split('-').map(num => parseInt(num, 10))
      fixedDate = new Date(year, month - 1, day)
    }

    // Create the fixed date in UTC
    // Use today's date at 00:00:00 local time

    let finalDate

    this.bundlesPropertiesElement = this.querySelector('[name="properties[_bundles_properties]"]')

    if (this.bundlesPropertiesElement) {
      this.bundlesProperties = JSON.parse(this.bundlesPropertiesElement.value)
    }

    if (fixedDate >= this.today) {
      finalDate = fixedDate
      if (this.bundlesPropertiesElement) {
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-fixed'] = (this.dateFormat(finalDate)).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-fixed-unix'] = (finalDate.valueOf()).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-rolling'] = (0).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-rolling-unix'] = (0).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_shipdate'] = (this.dateFormat(finalDate)).toString() // eslint-disable-line dot-notation
        this.bundlesPropertiesElement.value = JSON.stringify(this.bundlesProperties)
      } else {
        if (this.querySelector('.date-fixed')) {
          this.querySelector('.date-fixed').value = this.dateFormat(finalDate)
        }
        if (this.querySelector('.date-fixed-unix')) {
          this.querySelector('.date-fixed-unix').value = parseInt(finalDate.valueOf())
        }
        if (this.querySelector('.date-rolling')) {
          this.querySelector('.date-rolling').value = 0
        }
        if (this.querySelector('.date-rolling-unix')) {
          this.querySelector('.date-rolling-unix').value = 0
        }
      }
    } else {
      // Start with today's date if the fixed date is in the past
      finalDate = new Date(this.today)

      const countryIso = document.querySelector('body').dataset.countryCode
      
      if (countryIso === 'CA' || countryIso === 'US') {
        const offset = new Date().getTimezoneOffset()
        let centralCutOff = 12 + (6 - ((offset / 60)))
        // if (centralCutOff + new Date().getHours() >= 18)
        if (new Date().getHours() >= centralCutOff && new Date().getMinutes() >= 1) {
          rollingDays += 1
        }
      }

      // Loop through the number of days to add, skipping weekends
      for (let i = 0; i < rollingDays; i++) {
        finalDate.setDate(finalDate.getDate() + 1) // Move to the next day
          
        if (countryIso !== 'CA' && countryIso !== 'US') {
          const dayOfWeek = finalDate.getDay()
  
          if (dayOfWeek === 6) { // Saturday
            finalDate.setDate(finalDate.getDate() + 2) // Skip to Monday
          } else if (dayOfWeek === 0) { // Sunday
            finalDate.setDate(finalDate.getDate() + 1) // Skip to Monday
          }
        }
      }
      if (this.bundlesPropertiesElement) {
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-fixed'] = (0).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-fixed-unix'] = (0).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-rolling'] = (this.dateFormat(finalDate)).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_date-rolling-unix'] = (finalDate.valueOf()).toString()
        this.bundlesProperties[bundlesPropertiesPosition].attributes['_shipdate'] = (this.dateFormat(finalDate)).toString() // eslint-disable-line dot-notation
        this.bundlesPropertiesElement.value = JSON.stringify(this.bundlesProperties)
      } else {
        if (this.querySelector('.date-fixed')) {
          this.querySelector('.date-fixed').value = 0
        }
        if (this.querySelector('.date-fixed-unix')) {
          this.querySelector('.date-fixed-unix').value = 0
        }
        if (this.querySelector('.date-rolling')) {
          this.querySelector('.date-rolling').value = this.dateFormat(finalDate)
        }
        if (this.querySelector('.date-rolling-unix')) {
          this.querySelector('.date-rolling-unix').value = parseInt(finalDate.valueOf())
        }
      }
    }
    return finalDate
  }
}

if (!customElements.get('umg-dates')) {
  customElements.define('umg-dates', UMGDates)
}
